// Парсер body[data-shared] — единая точка чтения site_params.
// Аналог `sharedData.data.site_params` в website_default.

let cached = null;

export function getSiteParams() {
  if (cached) return cached;
  try {
    const raw = document.body.getAttribute('data-shared');
    const obj = raw ? JSON.parse(raw) : {};
    cached = obj.site_params || {};
  } catch (e) {
    cached = {};
  }
  return cached;
}

// Согласия — из site_consent_checkboxes; если пусто, фолбэк как в default.
export function getConsentItems() {
  const sp = getSiteParams();
  const items = sp.site_consent_checkboxes;
  if (Array.isArray(items) && items.length > 0) return items;
  return [{
    text: 'Я даю согласие на обработку моих персональных данных в соответствии с',
    link_title: 'Политикой обработки персональных данных и политикой конфиденциальности',
    link_url: '/conds',
    is_required: true,
    default_checked: true,
  }];
}



// WEBPACK FOOTER //
// ./app/javascript/website_newgen/js/shared/siteParams.js